import users from '../constants/userData.json';

function loginUser(data) {
    return new Promise((resolve, reject) => {
        const user = users.find(({ username, password }) => username === data.username && password === data.password);
        if (user) {
            localStorage.setItem('userAuthInfo', JSON.stringify(user));
            resolve({ isLoggedIn: true });
        } else {
            resolve({ errorMessage: 'Invalid username or password' });
        }
    });
}

function authenticateUser() {
    const user = localStorage.getItem("userAuthInfo");
    if (user) {
        const userDetails = JSON.parse(user);
        return { ...userDetails, isLoggedIn: true };
    } else {
        return { isLoggedIn: false };
    }

}

function userLogout() {
    localStorage.removeItem("userAuthInfo");
    return { isLoggedIn: false };

}

// function registerUser(data) {
//     return axios.post(basePath + '/register', data)
//         .then((response) => {
//             return response.data
//         })
// }

export const userServices = {
    loginUser,
    authenticateUser,
    userLogout
    // registerUser
};